import { render, staticRenderFns } from "./Song.vue?vue&type=template&id=0c6b90d4&scoped=true&"
import script from "./Song.vue?vue&type=script&lang=js&"
export * from "./Song.vue?vue&type=script&lang=js&"
import style0 from "./Song.vue?vue&type=style&index=0&id=0c6b90d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b90d4",
  null
  
)

export default component.exports